export const environment = {
  production: false,
  apiUrl: 'https://updates-dev.cover3d.com/api',
  keycloak: {
    url: 'https://auth.cover3d.com/auth/',
    realm: 'dev.cover3d.com',
    clientId: 'cover-systray'
  }
};
